>



<template>
    <div class="vue timparty-contest-list-ranking">
        <ul class="winners-list" v-if="winners_filtered">
            <li v-for="(winner, idx) in winners_filtered" v-bind:key="idx">
            <div class="row row-eq-height">
                <div class="col-2 d-flex align-items-center">
                    <div class="winner-position">
                    {{ idx + 1 }}°
                    </div>
                </div>
                <div class="col-4 d-flex align-items-center">
                    <span class="winner-name">{{ winner.name }}</span>
                </div>
                <div class="col-6 d-flex align-items-center">
                    <span class="winner-city">{{ winner.city }}</span>
                </div>
            </div>
            </li>
        </ul>
        <div v-else>
            <p class="text-black">Nessun vincitore trovato</p>
        </div>
    </div>
</template>

<script>

    /* eslint-disable */ 

    export default {
      name: 'ContentPrivacyPolicy',
      props: {
          winners: {
              type: Array,
              required: true,
          }
      },
      data: function(){
          return{
            winners_filtered: null,
          }
      },
      mounted: function(){
          this.winners_filtered = _.filter(this.winners, function( item ){ return item.name != ''; });
      }
    }

</script>


